import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '44a9e906-d3aa-49bb-b1ef-295d9cc2768f',
  clientToken: 'pub31112eaf63fc0f6cf2ac74bd5a5c6a4b',
  site: 'datadoghq.eu',
  service: 'tracking-pages',
  env: process.env.DATADOG_ENV,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});



// WEBPACK FOOTER //
// ./src/js/datadog-tracking.js